// Prefer environment-configured URL; fallback to previous hard-coded value if missing.
const GOOGLE_PAY_SDK_URL = process.env.VUE_APP_GOOGLE_PAY_SDK_URL || 'https://pay.google.com/gp/p/js/pay.js';

export function loadGooglePaySDK(): Promise<void> {
    return new Promise((resolve, reject) => {
        if (typeof google !== 'undefined' && google.payments) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = GOOGLE_PAY_SDK_URL;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load Google Pay SDK'));
        
        document.head.appendChild(script);
    });
}